import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from "@mui/material/Button";

import {email as validateEmail} from '../../helpers/validations';
import CustomTextField from '../common/CustomTextField';
import './ResetPasswordForm.scss'
import Stack from "@mui/material/Stack";

const ResetPasswordForm = props => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(props.defaultEmail || '');
  const [blurred, setBlurred] = useState(false);
  const formIsInvalid = (blurred || email) && !validateEmail(email);

  return (
    <Stack className='ResetPasswordForm'>
      {props.success
        ? <Alert severity='success'>
          Password reset sent!
        </Alert>
        : null
      }

      <CustomTextField
        id='emailInput'
        placeholder='jane.smith@gmail.com'
        helperText='Send an email to reset your password.'
        variant='outlined'
        label='Email'
        required
        type='email'
        error={formIsInvalid}
        onChange={e => setEmail(e.target.value)}
        onBlur={() => setBlurred(true)}
      />

      <Button
        size='medium'
        variant='primaryGradient'
        onClick={() => props.onSubmit({email})}
      >
        Reset Password
      </Button>

      <Button
        size='medium'
        variant='primaryOutline'
        onClick={() => navigate('/login')}
      >
        Login
      </Button>
    </Stack>
  );
};

export default ResetPasswordForm;
